<template>   
  <section ref="root" class="dc-container">   
    <!-- CONTENIDO -->   
    <div class="dc-card">   
        
      <!-- Título en dos líneas -->   
      <h2 ref="title" class="dc-title">   
        <span>Vestimenta</span><br />   
        <span class="script">Código</span>   
      </h2>   
   
      <!-- Etiqueta -->   
      <div ref="badge" class="dc-badge">FORMAL</div>   
        
      <img   
        ref="figure"   
        src="@/assets/codigo.png"   
        alt="Código de vestimenta"   
        class="dc-figure"   
      />   
   
     
    </div>   
   
    <!-- ONDA SVG EN LA PARTE INFERIOR -->   
    <div class="onda-svg-bottom"></div>   
   
  </section>   
</template>

<script>
import { ref, onMounted, nextTick, onUnmounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'DressCodeLuxuryExact',
  setup() {
    const root = ref(null)
    const title = ref(null)
    const badge = ref(null)
    const figure = ref(null)
    const note = ref(null)
    const colorsImage = ref(null) // Referencia para la nueva imagen

    onMounted(async () => {
      await nextTick()
      if (!root.value) return

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root.value,
          start: 'top 85%',
          once: true
        }
      })

      /* TÍTULO */
      tl.from(title.value, {
        opacity: 0,
        y: -24,
        filter: 'blur(6px)',
        duration: 0.6,
        ease: 'power3.out'
      })

      /* BADGE */
      tl.from(
        badge.value,
        {
          opacity: 0,
          y: -16,
          scale: 0.98,
          duration: 0.5,
          ease: 'back.out(1.6)'
        },
        '>-0.1'
      )

      /* FIGURA */
      tl.from(
        figure.value,
        {
          opacity: 0,
          scale: 0.9,
          duration: 0.55,
          ease: 'power2.out'
        },
        '>-0.05'
      )

      /* TEXTO ANIMADO */
      if (note.value) {
        const words = note.value.innerText.split(' ')
        note.value.innerHTML = words
          .map(word => `<span class="word">${word}</span>`)
          .join(' ')

        const wordSpans = note.value.querySelectorAll('.word')

        tl.from(
          wordSpans,
          {
            opacity: 0,
            y: 28,
            duration: 0.6,
            ease: 'power3.out',
            stagger: 0.12
          },
          '+=0.25'
        )
      }

      /* NUEVA ANIMACIÓN PARA LA IMAGEN DE COLORES */
      tl.from(
        colorsImage.value,
        {
          opacity: 0,
          y: 30,
          scale: 0.95,
          duration: 0.6,
          ease: 'power2.out'
        },
        '>-0.2' // Comienza poco antes de que termine la animación del texto
      )

    })

    onUnmounted(() => {
      ScrollTrigger.refresh()
    })

    return { root, title, badge, figure, note, colorsImage }
  }
}
</script>


<style scoped>
.dc-container {
  position: relative;
  max-width: 500px;
  margin: 0 auto;
  background: #adc3e4;
  padding: 34px 18px 50px;
  /* overflow debe ser visible para que la curva inferior sobresalga suavemente si se desea */
  overflow: visible;
  text-align: center;
}

/* ONDA SVG INFERIOR */
.onda-svg-bottom {
  position: absolute;
  bottom: -29px;
  left: 0;
  width: 100%;
  height: 30px;
background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 30' preserveAspectRatio='none'%3E%3Cpath d='M0,0 C25,30 75,30 100,0 Z' fill='%23adc3e4'/%3E%3C/svg%3E");    background-size: 100% 100%;
  background-repeat: no-repeat;
  z-index: 3;
  pointer-events: none;
}

.dc-card {
  position: relative;
  z-index: 2;
}

.dc-title {
  font-family: 'CynthiaJuneJF', cursive;
  font-size: 56px !important;
  background: linear-gradient(110deg, #a67c00 30%, #bf953f 45%, #ffffff 50%, #bf953f 55%, #a67c00 70%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  line-height: 1.5;
  color: transparent;
  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.3));
  display: block; 
}

.dc-title .script {
  font-family: 'CynthiaJuneJF', cursive;
  font-size: 56px !important;
  background: linear-gradient(110deg, #a67c00 30%, #bf953f 45%, #ffffff 50%, #bf953f 55%, #a67c00 70%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  line-height: 1.5;
  color: transparent;
  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.3));
  display: block; 
}

.dc-badge {
  display: inline-block;
  background-image: 
    linear-gradient(rgba(0, 0, 0, 0.041), rgba(0, 0, 0, 0.064)),
    url('@/assets/dorado.png');
  background-size: cover;
  background-position: center;
  color: #000000;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 18px;
  letter-spacing: 0.14em;
  padding: 8px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  margin: 4px 0 12px;
}

.dc-figure {
  width: 80%;
  margin: 10px auto 12px;
  display: block;
}

.dc-note {
  font-family: 'quote', serif;
  font-size: 20px;
  color: #ffffff;
  opacity: 0.9;
  font-style: italic;
  margin: 10px auto 18px;
}

/* ESTILO PARA LA NUEVA IMAGEN */
.dc-colors-image {
  width: 60%; /* Ajusta el tamaño según sea necesario */
  margin: 0 auto 20px;
  display: block;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.2));
}

/* spans del texto animado */
.word {
  display: inline-block;
  white-space: nowrap;
}
</style>